import PushNavigation from './PushNavigation';

const pushNavConfig = {
  name: 'pushNav',
  class: PushNavigation,
  querySelectorAll: {
    subNavTrigger: '.site-pushnav__submenu-trigger',
  },
  options: {
    toggleActiveClass: 'site-pushnav--toggleActivated',
    subNavActiveClass: 'site-pushnav__menu-item--subnav-active',
  },
};

export default pushNavConfig;



// WEBPACK FOOTER //
// ./client/js/components/Header/pushNavConfig.js